import { useEffect, useState } from "react";
import Table from "../../../components/table";
import AddModal from "./addModal";
import EditModal from "./editModal";
import DeleteModal from "./deleteModal";
import { FaRegEdit } from "react-icons/fa";
import { AiOutlineDelete } from "react-icons/ai";

const ManageAlerts = ({ alerts, fetchData }) => {
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [pushNotifications, setPushNotifications] = useState([]);
  const [selectedNotificationId, setSelectedNotificationId] = useState({});
  const [page, setPage] = useState(0);
  const alertsPerPage = 10;

  useEffect(() => {
    const tableRows = alerts?.map((notif) => {
      return {
        id: notif.id,
        users: notif?.users,
        title: notif?.title,
        description: notif?.description,
        scheduledDate: convertUTCToLocal(notif?.datetime),
        status: notif?.status,
        actions: () => getActionButtons(notif?.id, notif?.status),
      };
    });
    setPushNotifications(tableRows);
  }, [alerts]);

  function convertUTCToLocal(utcDateString) {
    const utcDate = new Date(utcDateString + "Z"); // Add 'Z' to indicate it's UTC
    return utcDate.toLocaleString(); // Converts to local time
  }

  const getActionButtons = (notifId, status) => {
    return (
      <div>
        {status == "PENDING" && (
          <button
            className="btn p-0 me-3"
            onClick={() => {
              setSelectedNotificationId(notifId);
              setIsEditOpen(true);
            }}
          >
            <FaRegEdit size={20} />
          </button>
        )}
        {status == "PENDING" && (
          <button
            className="btn p-0"
            onClick={() => {
              setSelectedNotificationId(notifId);
              setIsDeleteOpen(true);
            }}
          >
            <AiOutlineDelete size={20} />
          </button>
        )}
      </div>
    );
  };

  const headings = [
    // { name: "ID", fieldName: "id", isSortable: true, sortKey: "none" },
    {
      name: "Users",
      fieldName: "users",
      isSortable: false,
      sortKey: "none",
    },
    {
      name: "Title",
      fieldName: "title",
      isSortable: false,
      sortKey: "none",
    },
    {
      name: "Description",
      fieldName: "description",
      isSortable: false,
      sortKey: "none",
    },
    {
      name: "Scheduled Date",
      fieldName: "datetime",
      isSortable: false,
      sortKey: "none",
    },
    {
      name: "Status",
      fieldName: "status",
      isSortable: false,
      sortKey: "none",
    },
    {
      name: "Actions",
      fieldName: "actions",
      isSortable: false,
      sortKey: "none",
    },
  ];

  const totalPages = Math.ceil(alerts?.length / alertsPerPage);
  const displayedAlerts = pushNotifications?.slice(
    page * alertsPerPage,
    (page + 1) * alertsPerPage
  );

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 0 && pageNumber < totalPages) {
      setPage(pageNumber);
    }
  };

  return (
    <div>
      {/* <div className="d-flex justify-content-end">
          <Button text="Add Notification" callBack={() => setIsAddOpen(true)} />
        </div> */}
      <Table
        data={displayedAlerts}
        headings={headings}
        currentPage={page}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        enablePagination={alerts?.length > alertsPerPage}
        addBtnText="+ Add Notification"
        addCallback={() => setIsAddOpen(true)}
        card={true}
      />
      <AddModal
        isAddOpen={isAddOpen}
        closeAddModal={() => setIsAddOpen(false)}
        fetchData={fetchData}
      />
      <EditModal
        isEditOpen={isEditOpen}
        closeEditModal={() => setIsEditOpen(false)}
        id={selectedNotificationId}
        fetchData={fetchData}
      />
      <DeleteModal
        isDeleteOpen={isDeleteOpen}
        closeDeleteModal={() => setIsDeleteOpen(false)}
        id={selectedNotificationId}
        fetchData={fetchData}
      />
    </div>
  );
};

export default ManageAlerts;
